import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeProvider } from "styled-components";
import {
  AuthService,
  ErrorBoundary,
  GlobalStyles,
  Loader,
  theme,
  ToastKeeper,
} from "@mindmemobile/mm-shared-global";
import CacheControlStore from "./CacheControlStore";
import { Provider } from "mobx-react";
import UpdateNotifier from "./UpdateNotifier";
import { startVersionCheck, stopVersionCheck } from "./CacheControlService"; // Import the stream
import {
  FundraiserRoutes,
  fundraiserStore,
} from "@mindmemobile/mm-fundraiser-module";
import RoutesConfig from "./RoutesConfig";

const App: React.FC = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const cdn = process.env.REACT_APP_FWD_CDN;

    if (cdn) {
      script.src = cdn;
      script.async = true;
      document.head.appendChild(script);
    }

    startVersionCheck(); // Start the version check when the component mounts

    return () => stopVersionCheck(); // Cleanup function to stop the version check when the component unmounts
  }, []);

  return (
    <ErrorBoundary>
      <Provider cacheControlStore={CacheControlStore}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <UpdateNotifier />
          <RoutesConfig fromMain={true} />
          <ToastKeeper />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  );
};
export default App;
